/// <reference path="../../app.typings.d.ts" />
'use strict';
var app;
(function (app) {
    var Services;
    (function (Services) {
        var LocationService = /** @class */ (function () {
            function LocationService($location, $route, $routeParams, authenticationService, alphaOrganizationKey) {
                this.$location = $location;
                this.$route = $route;
                this.$routeParams = $routeParams;
                this.authenticationService = authenticationService;
                this.alphaOrganizationKey = alphaOrganizationKey;
                this.authData = this.authenticationService.authorizationData;
                this.routes = ap.Constants.routes;
            }
            LocationService.prototype.getOrganizationCacheKey = function (organizationList, useFirstOrganizationIfRouteParamIsMissing, reset) {
                if (ap.Utilities.isTrueValue(reset)) {
                    this.alphaOrganizationKey = undefined;
                }
                if (!ap.Utilities.isNullOrUndefined(this.alphaOrganizationKey)) {
                    return this.alphaOrganizationKey;
                }
                if (!ap.Utilities.isNullOrUndefined(this.$routeParams.organizationCacheKey)) {
                    return this.$routeParams.organizationCacheKey.toLowerCase();
                }
                //Failing the route param (i.e. WelcomePoint), grab updated auth data
                this.authData = this.authenticationService.authorizationData;
                if (ap.Utilities.isTrueValue(useFirstOrganizationIfRouteParamIsMissing) && !ap.Utilities.isNullOrUndefined(this.authData.OrganizationUnitCacheKey)) {
                    // RSC-1512 Fix for WP not loading auth key sometimes
                    this.alphaOrganizationKey = this.authData.OrganizationUnitCacheKey;
                }
                return this.alphaOrganizationKey;
            };
            LocationService.prototype.setOrganizationCacheKey = function (cacheKey) {
                this.alphaOrganizationKey = cacheKey || undefined;
            };
            LocationService.prototype.isOnPage = function (route) {
                if (ap.Utilities.isNullOrUndefined(route)) {
                    return false;
                }
                return this.$route.current.name === route.name;
            };
            LocationService.prototype.path = function () {
                return this.$location.path();
            };
            LocationService.prototype.redirect = function (route, reportName, organizationCacheKey) {
                if (!ap.Utilities.isNullOrUndefined(reportName)) {
                    if (!ap.Utilities.isNullOrUndefined(organizationCacheKey)) {
                        this.$location.path("/" + route.route + "/" + reportName + "/" + organizationCacheKey);
                    }
                    else {
                        this.$location.path("/" + route.route + "/" + reportName);
                    }
                }
                else if (!ap.Utilities.isNullOrUndefined(organizationCacheKey)) {
                    this.$location.path("/reports/" + organizationCacheKey);
                }
                else {
                    //for some reason the optional param is getting passed as an escaped string
                    if (route.route.indexOf(':organizationCacheKey') > -1) {
                        route.route = 'reports';
                    }
                    this.$location.path("/" + route.route);
                }
            };
            LocationService.prototype.search = function () {
                return this.$location.search();
            };
            LocationService.$inject = [
                '$location',
                '$route',
                '$routeParams',
                'authenticationService'
            ];
            return LocationService;
        }());
        Services.LocationService = LocationService;
        angular.module('app.Services')
            .service('locationService', LocationService);
    })(Services = app.Services || (app.Services = {}));
})(app || (app = {}));
